import axios from 'axios'
const Axios = axios.create({
    baseURL: 'http://youwei.jingmaie-co.cn',
    // baseURL:"http://192.168.16.23",
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        version: "2.3.2"
    }
})
// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(config => {
    if(sessionStorage.unique){ 
        config.headers.unique = sessionStorage.unique
      }
      return config;
}, error => {
    return Promise.reject(error)
})

Axios.install = (Vue) => {
    Vue.prototype.$http = Axios
}

export default {
    fetchGet(url, params = {},headers = {}) {
        return new Promise((resolve, reject) => {
            Axios.get(url, {
                params: params
            },headers).then(res => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    },
    fetchPost(url, params = {}, config = {}) {
        return new Promise((resolve, reject) => {
            Axios.post(url, params, config).then(res => {
                resolve(res)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
